import { Injectable } from '@angular/core';
import { from, Observable, of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { ConfigurationService } from 'src/app/services/configuration/configuration.service';
import { VuCommunicationService } from 'src/app/services/vu/vu-communication.service';
import { CardInformation } from '../models/card-information';

@Injectable()
export class RechargeCardService {

  constructor(
    private configurationService: ConfigurationService,
    private vuCommunicationService: VuCommunicationService,
  ) { }

  loadCardInformation(cardNumber: string): Observable<CardInformation> {
    return of(true).pipe(
      switchMap(() => {
        const requestValues = new Map<string, any>();
        requestValues.set('cardNumber', cardNumber);

        const paymentControllerUrl = this.configurationService.configuration.odooUrl + '/api/card/information';

        return from(this.vuCommunicationService.ExternalApiService.sendPostRequestOdooJson(paymentControllerUrl, requestValues))
          .pipe(
            catchError(error => {
              return of(false);
            }),
            map(result => {
              if (!result || !result.name) {
                return null;
              }
              return CardInformation.creatFromAny(result);
            }),
          );
      }),
    );
  }
}
